import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["headerText", "businessNameHeader"];

    connect() {
        document.body.style.setProperty("--brand-color", this.data.get('brandColour'));
        this.businessName = this.data.get("business-name");
        if (this.isInFrame()){
            this.hideBusinessNameHeader();
        }
    }

    set title(title){
        this.data.set("title", title);
        this.headerTextTarget.innerText = title;
    }

    get title() {
        this.data.get("title");
    }

    set businessName(businessName){
        this.data.set("businessName", businessName);
        this.businessNameHeaderTarget.innerText = businessName;
    }

    get businessName() {
        this.data.get("businessName");
    }

    updateTitle(event) {
        this.title = event.title;
    }

    isInFrame() {
        return window != window.top
    }

    hideBusinessNameHeader() {
        this.businessNameHeaderTarget.classList.toggle('hidden', true);
    }
}